module.exports = __webpack_public_path__ + "static/media/mem5YaGs126MiZpBA-UNirkOVuhpOqc.ff3904f6.woff2";